import React, { useEffect, useState, useRef } from "react";
import {
  TextField,
  InputAdornment,
  Button,
  FormHelperText,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import {
  validateMobileOTPAPICall,
  reSendMobileOTPAPICall,
  SaveIpAddressAPICall,
} from "../shared/APICalls";
import {
  IMobileOtpValidation,
  IReSendMobileOTP,
  ISaveIPaddress,
} from "../shared/dtos";
import routesData from "../shared/routes.json";
import ConfitmOtpStyles from "../pages/Styles/ConfitmOtpStyles.module.scss";
import SnackBar from "../Components/SnackBars/SnackBar";
import Slide, { SlideProps } from "@mui/material/Slide";
import firstockLogo from "../Components/assets/Images/Firstocklogo.svg";
import otpIcon from "../Components/assets/Images/otpIcon.svg";
import axios from "axios";
import TagManager from "react-gtm-module";
import LeftComp from "../Components/LeftComp/LeftComp";
import GooglePlayStore from "../Components/assets/Images/GooglePlayStore.svg";
import AppStore from "../Components/assets/Images/AppStore.svg";
import MicroSoft from "../Components/assets/Images/MicrosoftStore.svg";
import { MuiOtpInput } from "mui-one-time-password-input";
import fstlogo from "../Components/assets/Images/firstockLogoBadge.svg";
import leftcompimage from "../Components/assets/Images/SignupIllustration.svg";
import LeftCompNew from "../Components/LeftCompNew/LeftCompNew";

type TransitionProps = Omit<SlideProps, "direction">;

function TransitionUp(props: TransitionProps) {
  return <Slide {...props} direction="down" />;
}

const dots = ["1", "2", "3", "4", "5", "6"];

export default function ConfirmOtpPage() {
  const navigate = useNavigate();
  const mobile: any = sessionStorage.getItem("mobile");
  const latitude: any = sessionStorage.getItem("latitude");
  const longitude: any = sessionStorage.getItem("longitude");
  const [otp, setOTP] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [countdown, setCountdown] = useState<any>(30);
  const [timerId, setTimerId] = useState<any>(null);
  const [open, setOpen] = useState(false);
  const [wrongOTP, setWrongOTP] = useState(false);
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState("");
  const [IPAddress, setIPAddress] = useState("");
  const [transition, setTransition] = React.useState<
    React.ComponentType<TransitionProps> | undefined
  >(undefined);
  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  const [mode, setMode] = useState(getSystemTheme());

  useEffect(() => {
    setMode(getSystemTheme());
  }, [getSystemTheme]);

  const navigationData = routesData;

  useEffect(() => {
    window.scrollTo(0, 0);
    if (mobile === null) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    setIsButtonDisabled(true);
    setCountdown(30);

    if (timerId === null) {
      let interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      setTimerId(interval);
    }
  }, []);
  useEffect(() => {
    if (countdown <= 0 && timerId !== null) {
      setIsButtonDisabled(false);

      clearInterval(timerId);
      setTimerId(null);
    }
  }, [countdown]);

  function validateMobileOTP(data: any) {
    setloading(true);

    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitMobileotp",
        phone: data,
      },
    });

    const source = sessionStorage.getItem("source");
    const id = sessionStorage.getItem("id");

    let obj: IMobileOtpValidation = {
      mobile: mobile,
      mobile_otp: data,
      ref_source: source ? source : "web",
      ref_code: id ? id : "",
    };
    setTimeout(() => {
      validateMobileOTPAPICall(obj)
        .then((response: any) => {
          const responseData = response.data;
          // console.log("response", responseData);
          if (responseData.data.next_stage === "application_approved") {
            if (responseData.data.access_token) {
              // console.log("token", responseData.data.access_token);
              sessionStorage.setItem(
                "access-token",
                responseData.data.access_token,
              );
            }

            if (responseData.data.client_code) {
              sessionStorage.setItem(
                "client_id",
                responseData.data.client_code,
              );
            }
            navigate(navigationData[responseData.data.next_stage]);
          } else {
            if (responseData.data.access_token) {
              // console.log("token", responseData.data.access_token);
              sessionStorage.setItem(
                "access-token",
                responseData.data.access_token,
              );
            }

            if (responseData.data.client_code) {
              sessionStorage.setItem(
                "client_id",
                responseData.data.client_code,
              );
            }
            sessionStorage.removeItem("source");
            sessionStorage.removeItem("id");
            setloading(false);
            // setMessage(responseData.data.message);
            setWrongOTP(false);
            let objIPAddress: ISaveIPaddress = {
              latitude: latitude,
              longitude: longitude,
            };
            SaveIpAddressAPICall(objIPAddress)
              .then((response: any) => {
                // console.log("responseIPSave", response.data);
                if (
                  responseData.data.next_stage &&
                  navigationData.hasOwnProperty(responseData.data.next_stage)
                ) {
                  navigate(navigationData[responseData.data.next_stage]);
                }
              })
              .catch((error: any) => {
                if (error.response.data.message) {
                  setMessage(
                    error.message.includes("Network")
                      ? "Error occured, Please try again"
                      : error.response.data.message,
                  );
                } else {
                  setMessage("Error occured, Please try again");
                }
                setloading(false);
                setTimeout(() => {
                  setMessage("");
                }, 5000);
              });
          }
        })
        .catch((error: any) => {
          // console.log(error.response.status);
          setWrongOTP(true);
          setloading(false);
          if (error.response.status === 404) {
            setMessage("Failed to Continue, Please try Again");
            setTimeout(() => {
              setMessage("");
            }, 5000);
          }
          setMessage(
            error.message.includes("Network")
              ? "Error occured, Please try again"
              : error.response.data.message,
          );
          setTimeout(() => {
            setMessage("");
          }, 5000);
        });
    }, 500);
  }

  function reSendMobileOTP() {
    let obj: IReSendMobileOTP = {
      mobile: mobile,
    };
    reSendMobileOTPAPICall(obj)
      .then((response: any) => {
        const responseData = response.data.data;
        setloading(false);
        setTransition(() => TransitionUp);
        setOpen(true);
        setTimeout(() => {
          setOpen(false);
        }, 3000);
        setIsButtonDisabled(true);
        setCountdown(30);
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          setMessage("Failed to Continue, Please try Again");
          setTimeout(() => {
            setMessage("");
          }, 5000);
        }
        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message,
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });

    if (timerId === null) {
      let interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      setTimerId(interval);
    }
  }
  const handleResendOTP = () => {
    setloading(true);
    reSendMobileOTP();
  };
  const handleBackClick = () => {
    navigate("/");
  };

  function validateOTP(value: any) {
    let error: any;
    if (!value) {
      error = "OTP Required";
    } else if (!/^[0-9]{6}$/.test(value)) {
      error = "Must be a valid 6 digit OTP";
    }
    return error;
  }

  const handleChangeField = (
    name: any,
    value: any,
    setFieldValue: any,
    values: any,
  ) => {
    setFieldValue(name, value);
    // console.log(value);
    if (value.length === 6) {
      validateMobileOTP(value);
    }
  };

  const handleKeyPress = (event: any) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const isValidKey = /^\d+$/.test(keyValue);

    if (!isValidKey) {
      event.preventDefault();
    }
  };

  return (
    <>
      <SnackBar message={message} />
      <div className={ConfitmOtpStyles.layout}>
        <div className={ConfitmOtpStyles.sidebar}>
          <LeftCompNew />
        </div>
        <div className={ConfitmOtpStyles.pageContent}>
          <div className={ConfitmOtpStyles.wrapper}>
            <div className={ConfitmOtpStyles.RightContainer}>
              <div className={ConfitmOtpStyles.contentSection}>
                <div className={ConfitmOtpStyles.headerSection}>
                  <img
                    src={fstlogo}
                    alt=""
                    className={ConfitmOtpStyles.fstlogo}
                    // style={{
                    //   filter:
                    //     mode === "dark"
                    //       ? "grayscale(0.9) invert(0.9) brightness(1)"
                    //       : "",
                    // }}
                  />
                  <p className={ConfitmOtpStyles.signup}>Enter the code</p>
                  <p className={ConfitmOtpStyles.subText}>
                    We sent a 6-digit code to your{" "}
                    <span>+91&nbsp;{mobile}</span>
                    <a
                      onClick={handleBackClick}
                      className={ConfitmOtpStyles.change}
                    >
                      Change
                    </a>
                  </p>
                </div>

                <div className={ConfitmOtpStyles.imageContainer}>
                  <LeftCompNew />
                </div>
                <Formik
                  initialValues={{
                    mobileotp: "",
                  }}
                  onSubmit={(values) => {
                    // console.log(values);
                    setloading(true);

                    validateMobileOTP(values.mobileotp);
                  }}
                >
                  {({
                    errors,
                    touched,
                    handleChange,
                    values,
                    handleSubmit,
                    setFieldValue,
                  }) => (
                    <Form
                      onKeyDown={(event) => {
                        // event.code === "Enter" ||
                        //   (event.code === "NumpadEnter" && handleSubmit());
                        event.code === "Enter" && handleSubmit();
                      }}
                      style={{ width: "100%" }}
                    >
                      <div className={ConfitmOtpStyles.muiotp}>
                        <MuiOtpInput
                          length={6}
                          value={values.mobileotp}
                          autoFocus
                          onChange={(event: any) => {
                            const updatedValue = event;

                            // setFieldValue(
                            //   "emailotp",
                            //   updatedValue,
                            // );
                            handleChangeField(
                              "mobileotp",
                              updatedValue,
                              setFieldValue,
                              values,
                            );
                          }}
                          inputMode="numeric"
                          onKeyPress={handleKeyPress}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 0,
                              borderBottom: "1.5px solid #EDEDED !important",

                              "& fieldset": {
                                border: "none",
                              },

                              "&:hover fieldset": {
                                border: "none",
                              },

                              "&.Mui-focused fieldset": {
                                border: "none",
                              },
                            },
                            "& .MuiOutlinedInput-root.Mui-focused": {
                              borderBottom: "1.5px solid #535862 !important", // 🔵 focus color
                            },

                            "& .MuiOutlinedInput-input": {
                              borderRadius: 0,
                              padding: "0px !important",
                              height: "60px",
                              background: "transparent",
                            },
                          }}
                        />
                        {/* <Field
                          name="mobileotp"
                          validate={validateOTP}
                          render={({ field }) => (
                            <TextField
                              autoComplete="off"
                              autoFocus
                              {...field}
                              sx={{
                                fieldset: {
                                  borderColor: "#E5E7EB",
                                  borderRadius: "100px",
                                  height: "60px",
                                },
                                background: "transparent",
                              }}
                              label=""
                              InputLabelProps={{ shrink: false }}
                              placeholder=""
                              // placeholder="••••••"
                              type="numeric"
                              className={ConfitmOtpStyles.textfield}
                              variant="outlined"
                              value={values.mobileotp}
                              onChange={(event) => {
                                const updatedValue = event.target.value;
                                handleChangeField(
                                  "mobileotp",
                                  updatedValue,
                                  setFieldValue,
                                  values,
                                );
                              }}
                              inputProps={{
                                sx: {
                                  "&::placeholder": {
                                    paddingLeft: "-20px",

                                    fill: "var(--Black-Black-500, #6B7280)",
                                    fontWeight: 600,
                                    fontSize: "2.19rem",
                                    background: "transparent",
                                    height: "29px",
                                    letterSpacing: { xs: "23px", sm: "19px" },
                                  },
                                  // borderLeft: "1px solid #E5E7EB",
                                  // height: "30px",
                                  paddingLeft: "-20px",

                                  fontWeight: 500,
                                  letterSpacing: { xs: "29.5px", sm: "24.5px" },

                                  background: "transparent",
                                },
                                maxLength: 6,
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                              }}
                              onKeyPress={(event) => {
                                const keyCode = event.keyCode || event.which;
                                const keyValue = String.fromCharCode(keyCode);
                                const isValidKey = /^\d+$/.test(keyValue);

                                if (!isValidKey) {
                                  event.preventDefault();
                                }
                              }}
                            />
                          )}
                        /> */}
                        <FormHelperText
                          style={{
                            color: "#d32f2f",
                            // height: "10px",
                            marginTop: "3px",
                            textAlign: "center",
                          }}
                        >
                          {touched.mobileotp && errors.mobileotp?.toString()}
                        </FormHelperText>
                      </div>

                      {isButtonDisabled ? (
                        <div className={ConfitmOtpStyles.resendSection}>
                          <p className={ConfitmOtpStyles.clickhere}>
                            Resend OTP in{" "}
                            <span style={{ color: "var(--ds-blue)" }}>
                              {countdown}
                            </span>{" "}
                            Seconds
                          </p>
                        </div>
                      ) : (
                        <div className={ConfitmOtpStyles.resendSection}>
                          <LoadingButton
                            onClick={() => {
                              setFieldValue("mobileotp", "");
                              handleResendOTP();
                            }}
                            disableFocusRipple
                            disableTouchRipple
                            disableElevation
                            size="small"
                            focusRipple={false}
                            //loading={loading}
                            variant="text"
                            id="confirmMobileOtpResendOtpButton"
                            sx={{
                              marginTop: "16px",
                              color: "var(--ds-blue)",
                              height: "25px !important",
                              padding: "0px 10px",
                              fontSize: "12px",
                            }}
                          >
                            Resend OTP
                          </LoadingButton>
                        </div>
                      )}

                      <div className={ConfitmOtpStyles.descriptionMobile}>
                        <div className={ConfitmOtpStyles.text1}>
                          Firstock Broking (P) Ltd: NSE & BSE - SEBI
                        </div>
                        <div className={ConfitmOtpStyles.text1}>
                          Registration No. INZ000260334
                          | CDSL - SEBI Registration No : IN-
                        </div>
                        <div className={ConfitmOtpStyles.text1}>
                          DP-67-2015 | Mutual Fund ARN: 132812 | Smart Online
                          Dispute
                        </div>
                        <div className={ConfitmOtpStyles.text1}>
                          Resolution | SEBI SCORES
                        </div>
                      </div>

                      <div className={ConfitmOtpStyles.buttonSection}>
                        {values.mobileotp.length === 6 ? (
                          <LoadingButton
                            variant="contained"
                            type="submit"
                            loading={loading}
                            id="confirmMobileOtpContinueButton"
                            className={ConfitmOtpStyles.button}
                            onClick={() => {
                              handleSubmit();
                            }}
                          >
                            {loading ? (
                              <CircularProgress
                                style={{
                                  color: "inherit",
                                  width: "20px",
                                  height: "20px",
                                }}
                              />
                            ) : (
                              "Continue"
                            )}
                          </LoadingButton>
                        ) : (
                          <Button
                            variant="contained"
                            disabled
                            id="confirmMobileOtpContinueDisabledButton"
                            className={ConfitmOtpStyles.button}
                          >
                            Continue
                          </Button>
                        )}
                      </div>

                      <Snackbar
                        open={open}
                        autoHideDuration={3000}
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        TransitionComponent={transition}
                        sx={{ marginTop: "50px" }}
                      >
                        <div
                          style={{
                            background: "#54BF00",
                            borderRadius: "10px ",
                          }}
                        >
                          <div style={{ marginLeft: "30px" }}>
                            <Alert
                              icon={false}
                              severity="success"
                              sx={{
                                width: "max-content",
                                height: "50px",
                                fontSize: "16px",
                                borderRadius: "0",
                              }}
                            >
                              Successfully sent the OTP to your Mobile.
                            </Alert>
                          </div>
                        </div>
                      </Snackbar>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>

            <div className={ConfitmOtpStyles.cardFooter}>
              <div className={ConfitmOtpStyles.footerLinks}>
                <a
                  className={ConfitmOtpStyles.footerItem}
                  href="https://firstock.in/faq/"
                  target="_blank"
                  rel="noreferrer"
                >
                  FAQ
                </a>
                <span className={ConfitmOtpStyles.footerSep} aria-hidden="true">
                  ·
                </span>
                <a
                  className={ConfitmOtpStyles.footerItem}
                  href="https://firstock.in/support/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Support
                </a>
              </div>

              <p className={ConfitmOtpStyles.termsAck}>
                By continuing, you agree to our{" "}
                <a
                  href="https://firstock.in/terms"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms
                </a>{" "}
                &amp;{" "}
                <a
                  href="https://firstock.in/privacy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
                .
              </p>
            </div>

            {/* <div className={ConfitmOtpStyles.firstockApps}>
              <div className={ConfitmOtpStyles.apps}>
                <a
                  href="https://play.google.com/store/apps/details?id=in.firstock.mobile"
                  target="_blank"
                >
                  <img
                    src={GooglePlayStore}
                    className={ConfitmOtpStyles.Googlestoreimage}
                  />
                </a>

                <a
                  href="https://apps.apple.com/us/app/firstock-trade-invest/id6746480444"
                  target="_blank"
                >
                  <img
                    src={AppStore}
                    className={ConfitmOtpStyles.Appstoreimage}
                  />
                </a>

                <a href="https://firstock-common.s3.ap-south-1.amazonaws.com/app/Firstock_INV_Live_Firstock_2023.7.4-setup.zip">
                  <img
                    src={MicroSoft}
                    className={ConfitmOtpStyles.Microstoreimage}
                  />
                </a>
              </div>
              <div className={ConfitmOtpStyles.description}>
                <div className={ConfitmOtpStyles.text1}>
                  Firstock Broking (P) Ltd: NSE & BSE - SEBI
                </div>
                <div className={ConfitmOtpStyles.text1}>
                  Registration No. INZ000260334 | CDSL - SEBI Registration No :
                  IN-
                </div>
                <div className={ConfitmOtpStyles.text1}>
                  DP-67-2015 | Mutual Fund ARN: 132812 | Smart Online Dispute
                  Resolution | SEBI SCORES
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
